import request from '@/utils/request';
export const defaultCompanyData = {
  id: 0,
  enabled: true,
  name: '',
  gstNumber: null,
  panNumber: null,
  addressLine1: '',
  addressLine2: '',
  bankAccountNumber: null,
  bankBranch: null,
  bankIfscCode: null,
  bankName: null,
  logo: null,
  pincodeId: null,
  pincode: {
    id: null
  }
};
export const getCompanies = params => request({
  url: '/companies',
  method: 'get',
  params
});
export const getCompanyById = id => request({
  url: `/companies/${id}`,
  method: 'get'
});
export const updateCompany = (id, data) => request({
  url: `/companies/${id}`,
  method: 'patch',
  data
});
export const deleteCompany = id => request({
  url: `/companies/${id}`,
  method: 'delete'
});
export const createCompany = data => request({
  url: '/companies/',
  method: 'post',
  data
});